<div class="option-group">
  <span *ngFor="let item of items.slice(0, 2); let j = index">
    {{ item[label] }}<span *ngIf="j < 1 && items.length > 1">, </span>
  </span>

  <div class="option-dropdown-wrapper">
    <span
      [class.hidden]="items.length <= 2"
      class="option-show-more"
      (click)="onToggleClick()"
    >
      +{{ items.length - 2 }} {{ "COMMON.MORE" | translate }}
      <span class="arrow">
        <img src="assets/icons/arrow.svg" width="15" height="15" alt="arrow" />
      </span>
    </span>

    <div *ngIf="isOpen" class="option-dropdown-box">
      <ul>
        <li *ngFor="let item of items">{{ item[label] }}</li>
      </ul>
    </div>
  </div>
</div>
